// extracted by mini-css-extract-plugin
export default {"nameHeading":"Header_nameHeading__JQXGu"};